/*
 * Copyright (c) 2026 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { PageQueryParams } from '../api/apiCommon.typings';
import { CashRegistersListAction, CashRegistersListActionType } from 'data/actions/cashRegistersActions';
import { CashRegistersListTableData } from 'components/RegistryWidgets/CashRegisters/CashRegistersList/CashRegistersListConfig';
import { CashRegistersListDto, CashRegistersListFilterParams } from 'data/api/cashRegister/cashRegistersClient.typings';

export const rowsPerPage = [20, 30, 40];
export const defaultSearchType: keyof CashRegistersListTableData = 'factoryNumber';
export const defaultPaginationLimit = rowsPerPage[0];
export const defaultRegisterFilter: boolean = null;

export interface CashRegistersListState {
    cashRegistersList: CashRegistersListDto;
    pageParams: PageQueryParams;
    filterParams: CashRegistersListFilterParams;
    changedFilterParams: CashRegistersListFilterParams;
    isLoading: boolean;
}

const initialState: CashRegistersListState = {
    cashRegistersList: {
        count: 0,
        cashRegisters: [],
    },
    pageParams: {
        limit: defaultPaginationLimit,
        offset: 0,
    },
    filterParams: {
        search_type: defaultSearchType,
        search_text: '',
        statuses: [],
        operatorTaxNumber: [],
        register: defaultRegisterFilter,
    },
    changedFilterParams: null,
    isLoading: false,
};

export function cashRegistersListReducer(
    state: CashRegistersListState = initialState,
    action: CashRegistersListAction,
): CashRegistersListState {
    switch (action.type) {
        case CashRegistersListActionType.OPEN_REGISTRY_CASH_REGISTERS_LIST_PAGE:
            return {
                ...state,
                isLoading: true,
            };

        case CashRegistersListActionType.APPLY_PAGING:
            return {
                ...state,
                isLoading: true,
                pageParams: action.payload,
                changedFilterParams: null,
            };

        case CashRegistersListActionType.APPLY_FILTERS:
            return {
                ...state,
                isLoading: true,
                pageParams: { ...state.pageParams, offset: 0 },
                filterParams: state.changedFilterParams ? { ...state.changedFilterParams } : { ...state.filterParams },
                changedFilterParams: null,
            };

        case CashRegistersListActionType.CHANGE_FILTERS:
            return {
                ...state,
                changedFilterParams: action.payload,
            };

        case CashRegistersListActionType.FETCH_CASH_REGISTERS_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                cashRegistersList: action.payload.list,
            };

        case CashRegistersListActionType.FETCH_CASH_REGISTERS_LIST_ERROR:
            return {
                ...state,
                isLoading: false,
                cashRegistersList: {
                    count: 0,
                    cashRegisters: [],
                },
            };

        case CashRegistersListActionType.EXIT_REGISTRY_CASH_REGISTERS_LIST_PAGE:
            return {
                ...state,
                cashRegistersList: {
                    count: 0,
                    cashRegisters: [],
                },
                changedFilterParams: null,
            };

        default:
            return state;
    }
}
